import { foreignKey, pgTable, text, unique, uuid } from 'drizzle-orm/pg-core';
import { orgPrimaryKey, orgTableBase } from '../org-id';
import { relations } from 'drizzle-orm';
export const BodyPart = pgTable('body_part', {
    ...orgTableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    nameUq: unique().on(table.orgId, table.name),
}));
export const Equipment = pgTable('equipment', {
    ...orgTableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    nameUq: unique().on(table.orgId, table.name),
}));
export const TrainingFocus = pgTable('training_focus', {
    ...orgTableBase,
    name: text('name').notNull(),
    trainingTypeId: uuid('training_type_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    typeFk: foreignKey({
        columns: [table.orgId, table.trainingTypeId],
        foreignColumns: [TrainingType.orgId, TrainingType.id],
    }),
}));
export const TrainingFocus_Relations = relations(TrainingFocus, ({ one }) => ({
    trainingType: one(TrainingType, {
        fields: [TrainingFocus.orgId, TrainingFocus.trainingTypeId],
        references: [TrainingType.orgId, TrainingType.id],
    }),
}));
export const TrainingType = pgTable('training_type', {
    ...orgTableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    nameUq: unique().on(table.orgId, table.name),
}));
//# sourceMappingURL=index.js.map